import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import FormProvider from "../../components/hookForm/FormProvider";
import RHFTextFieldAdd from "../../components/hookForm/RHFTextFieldAdd";
import classNames from "classnames/bind";
import Styles from "./AddUserForm.module.scss";
import { Alert, IconButton, InputAdornment } from "@mui/material";
import { RHFRadioGroup } from "../../components/hookForm";
import { FaPen } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { addUser, getAllUsers } from "../../redux/slices/app";

const cx = classNames.bind(Styles);

const ChangePasswordForm = ({ onHide }) => {
  const dispatch = useDispatch();

  const { user_id } = useSelector((state) => state.auth);
  const { users } = useSelector((state) => state.app);

  useEffect(() => {
    getAllUsers();
  }, []);

  const userLogged = users?.filter((item) => item._id === user_id)[0];

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [changePassword, setChangePassword] = useState(false);

  const EditUserSchema = Yup.object().shape({
    fullName: Yup.string().required("Por favor, introduce tu nombre completo"),
    phone: Yup.string()
      .matches(/^[0-9]+$/, "Por favor, introduce solo números")
      .required("Por favor, introduce tu número de teléfono"),
    currentPassword: Yup.string().required(
      "Por favor, introduce tu contraseña actual"
    ),
    password: Yup.string()
      .min(6, "La contraseña debe tener al menos 6 caracteres")
      .required("Por favor, introduce tu contraseña"),
    confirmPassword: Yup.string()
      .required("Por favor, introduce tu contraseña de confirmación")
      .oneOf([Yup.ref("password"), null], "Las contraseñas deben coincidir"),
  });

  const methods = useForm({
    resolver: yupResolver(EditUserSchema),
    defaultValues: {
      fullName: userLogged?.full_name || "",
      phone: userLogged?.phone_number || "",
      currentPassword: "",
      password: "",
      confirmPassword: "",
    },
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = async (data) => {
    try {
      dispatch(addUser(data));
      reset();
      setChangePassword(false);
    } catch (err) {
      console.log(err);
      reset();
      setError("afterSubmit", {
        ...err,
        message: err.message,
      });
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    reset();
    onHide();
    setChangePassword(false);
  };

  useEffect(() => {
    reset();
  }, [onHide]);

  return (
    <FormProvider
      methods={methods}
      onSubmit={handleSubmit(onSubmit)}
      className={cx("wrapper")}
    >
      <div className={cx("wrapper-input")}>
        <div className={cx("wr-input")}>
          <span className={cx("input-title")}>Nombre completo</span>
          <RHFTextFieldAdd
            name="fullName"
            placeholder="Introduce tu nombre"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <FaPen />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className={cx("wr-input")}>
          <span className={cx("input-title")}>Número de teléfono</span>
          <RHFTextFieldAdd
            name="phone"
            placeholder="IIntroduce tu número de teléfono"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <FaPen />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>

        {changePassword ? (
          <>
            <div className={cx("wr-input")}>
              <span className={cx("input-title")}>Contraseña actual</span>
              <RHFTextFieldAdd
                name="currentPassword"
                type={showCurrentPassword ? "text" : "password"}
                placeholder="Introduce tu contraseña actual"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowCurrentPassword(!showCurrentPassword)
                        }
                        edge="end"
                      >
                        {showCurrentPassword ? (
                          <FaEye fontSize={20} />
                        ) : (
                          <FaEyeSlash fontSize={20} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className={cx("wr-input")}>
              <span className={cx("input-title")}>Contraseña</span>
              <RHFTextFieldAdd
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Introduce tu contraseña"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? (
                          <FaEye fontSize={20} />
                        ) : (
                          <FaEyeSlash fontSize={20} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className={cx("wr-input")}>
              <span className={cx("input-title")}>Confirmar contraseña</span>
              <RHFTextFieldAdd
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Vuelve a introducir tu contraseña de confirmación"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <FaEye fontSize={20} />
                        ) : (
                          <FaEyeSlash fontSize={20} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </>
        ) : (
          <div
            className={cx("change-password")}
            onClick={() => setChangePassword(true)}
          >
            Cambiar contraseña
          </div>
        )}

        {!!errors.afterSubmit && (
          <Alert severity="error">{errors.afterSubmit.message}</Alert>
        )}
      </div>

      <div className={cx("footer-btn")}>
        <button className={cx("close-btn")} onClick={handleClose}>
          Cancelar
        </button>
        <button className={cx("submit-btn")}>Guardar cambios</button>
      </div>
    </FormProvider>
  );
};

export default ChangePasswordForm;
